import React, { useEffect, useState } from "react";
import { array, object } from "prop-types";
import get from "lodash/get";
import { ClientSideOnly, ResponsiveImage } from "@quintype/components";

import { SvgIconHandler } from "../svg-icon-hadler";
import { getAAuthor } from "../../helper/api";

import "./author.m.css";

const AuthorAvatar = ({ author }) => {
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];
  let imageView = null;

  if (avatarURL) {
    imageView = (
      <ResponsiveImage styleName="author-img" slug={avatarURL} aspectRatio={[1, 1]} alt={name.substring(1)} />
    );
  } else if (authorAvatarUrl) {
    imageView = <img styleName="author-img" src={authorAvatarUrl} alt={name.substring(1)} />;
  } else {
    imageView = (
      <div styleName="default-author-img">
        <SvgIconHandler type="authoruser" />
      </div>
    );
  }

  return <ClientSideOnly>{imageView}</ClientSideOnly>;
};

AuthorAvatar.propTypes = {
  author: object
};

const Author = ({ author }) => {
  const { slug, name, id } = author;
  const [authorDetails, setAuthorDetails] = useState({});
  const authorRole = get(authorDetails, ["metadata", "is_DHNS"], "");

  useEffect(() => {
    async function fetchAuthor() {
      await getAAuthor(id).then(({ author }) => setAuthorDetails(author));
    }
    fetchAuthor();
  }, []);

  return (
    <>
      <div styleName="author-wrapper">
        <div styleName="author-avatar">
          <AuthorAvatar author={author} />
        </div>
        <div styleName="author-text-wrapper">
          <div styleName="author-name">
            <a href={`/author/${slug}`}>{name}</a>
          </div>
          {["yes", "Yes", "true", "True", "t", "T"].includes(authorRole) ? (
            <>
              <div styleName="small-line"></div>
              <p styleName="dh-news">DHNS</p>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

Author.propTypes = {
  author: object
};

const Authors = ({ authors }) => {
  return (
    <div styleName="authors-wrapper">
      {authors &&
        authors.map((author, index) => {
          return (
            <div key={index}>
              <Author author={author} />
            </div>
          );
        })}
    </div>
  );
};

Authors.propTypes = {
  authors: array
};

export default Authors;
